import React, { useEffect, useCallback } from 'react';

function DesignModal({ design, onClose, onUsePrompt, onLike }) {
  // Close on Escape key
  const handleKey = useCallback((e) => {
    if (e.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [handleKey]);

  if (!design) return null;

  const handleUsePrompt = () => {
    if (onUsePrompt) {
      onUsePrompt(design.prompt, design.image_url, design.id);
    }
    onClose();
    setTimeout(() => {
      document.getElementById('create')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const formattedDate = design.created_at
    ? new Date(design.created_at).toLocaleDateString('en-US', {
        year: 'numeric', month: 'long', day: 'numeric',
      })
    : null;

  return (
    <div className="design-modal-backdrop" onClick={handleBackdropClick}>
      <div className="design-modal">
        {/* Close button */}
        <button className="design-modal-close" onClick={onClose} aria-label="Close">
          ✕
        </button>

        <div className="design-modal-content">
          {/* Image */}
          <div className="design-modal-image-wrap">
            <img
              src={design.image_url}
              alt={design.prompt}
              className="design-modal-image"
            />
          </div>

          {/* Info panel */}
          <div className="design-modal-info">
            <div className="design-modal-meta">
              {formattedDate && (
                <span className="design-modal-date">🗓 {formattedDate}</span>
              )}
            </div>

            <h3 className="design-modal-prompt-label">Prompt</h3>
            <p className="design-modal-prompt">"{design.prompt}"</p>

            <div className="design-modal-stats">
              <span className="design-modal-likes">
                {design.user_liked ? '❤️' : '🤍'} {design.likes > 0 ? design.likes : 0} likes
              </span>
            </div>

            <div className="design-modal-actions">
              <button
                className="design-modal-like-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  if (onLike) onLike(design);
                }}
                disabled={typeof design.id === 'string'}
              >
                {design.user_liked ? '💔 Unlike' : '❤️ Like'}
              </button>

              <button
                className="design-modal-use-btn"
                onClick={handleUsePrompt}
              >
                ✨ Use this prompt
              </button>
            </div>

            <p className="design-modal-hint">Press <kbd>Esc</kbd> to close</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DesignModal;
